import type { DeepRequired } from 'ts-essentials';

import { createDefaultText, drawingType } from '../internal';
import type { DrawingElement, SuggestedDrawingEdit } from '../internal';

export interface DefaultDrawingArgs {
  drawingImgId: string;
  drawingProps?: Partial<DrawingElement>;
  suggestedEdits?: SuggestedDrawingEdit[];
}

export interface InlineDrawingProps {
  cx: string;
  cy: string;
  embed: string;
  id: string;
  descr?: string;
  flipH?: string;
  flipV?: string;
  name?: string;
  offX?: string;
  offY?: string;
  rot?: string;
  title?: string;
}

export function createInlineDrawingProps(
  props: InlineDrawingProps
): DeepRequired<Pick<DrawingElement, 'inline'>> {
  const {
    cx,
    cy,
    descr = '',
    embed,
    flipH = '0',
    flipV = '0',
    id,
    name = '',
    offX = '0',
    offY = '0',
    rot = '0',
    title = '',
  } = props;

  return {
    inline: {
      docPr: {
        descr,
        id,
        name,
        title,
      },
      extent: {
        cx,
        cy,
      },
      graphic: {
        graphicData: {
          pic: {
            blipFill: {
              blip: {
                embed,
              },
              srcRect: { b: '0', l: '0', r: '0', t: '0' },
            },
            nvPicPr: {
              cNvPicPr: {
                preferRelativeResize: '0',
              },
              cNvPr: {
                descr,
                id: '', // this id is different from drawingImgId
                name,
                title,
              },
            },
            spPr: {
              xfrm: {
                ext: {
                  cx,
                  cy,
                },
                flipH,
                flipV,
                off: {
                  x: offX,
                  y: offY,
                },
                rot,
              },
            },
          },
        },
      },
    },
  };
}

export function createDefaultDrawing(args: DefaultDrawingArgs): DrawingElement {
  const { drawingImgId, drawingProps = {}, suggestedEdits = [] } = args;

  return {
    children: [createDefaultText()],
    drawingImgId,
    suggestedEdits,
    type: drawingType,
    ...drawingProps,
  };
}
